import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getMasterBookSets = async () => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      "/master_book_sets",
      {},
      false,
      null,
      "Migrated"
    );
    console.log("getMasterBookSets response.data :>> ", response.data);
    store.commit("ticketing/setMasterBookSets", response.data);
  } catch (err) {
    console.log('ERROR"" getMasterBookSets():', err);
    throw err;
  }
  return response.data;
};
